"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContentWrapper = exports.StateWrapper = void 0;
const components_core_1 = require("@volkswagen-onehub/components-core");
exports.StateWrapper = components_core_1.styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
`;
exports.ContentWrapper = components_core_1.styled.div `
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-flow: column;
  padding-top: 50px;
  width: 100vw;

  @media (min-width: ${components_core_1.Breakpoints.b560}px) {
    justify-content: center;
    height: auto;
    padding-bottom: 250px;
    padding-top: 250px;
  }
  @media (min-width: ${components_core_1.Breakpoints.b1280}px) {
    justify-content: center;
    height: auto;
    padding-bottom: 100px;
    padding-top: 100px;
  }
`;
